<script setup>
  import { ref, nextTick, watchEffect } from 'vue'
  import { useFocusTrap } from '@vueuse/integrations/useFocusTrap';  
  import CloseButton from '../CloseButton.vue';

  // TODO: Add click out side to close
  const props = defineProps({
    allowOutsideClick: {
      type: Boolean,
      default: true
    },
    hideCloseButton: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: 'auto'
    },
    height: {
      type: String,
      default: 'auto'
    },
    cleanup: {
      type: Function,
      default: () => {}
    }
  });

  const model = defineModel();

  let modal = ref(null);
  let showModal = ref(false);

  const { activate, deactivate } = useFocusTrap(modal, { allowOutsideClick: () => props.allowOutsideClick, returnFocusOnDeactivate: false })

  async function activateFocusTrap() {
    await nextTick();
    activate();
  }

  function handleCloseModal() {
    model.value = false;
    deactivate();
  }

  watchEffect(() => {    
    showModal.value = model.value;

    if (!showModal.value) return;

    activateFocusTrap();
  })

  watchEffect(() => {
    if (showModal.value) return;

    deactivate();
    props.cleanup();
  })
</script>

<template>
  <Teleport to="body">
    <Transition name="show-modal">
      <div v-if="showModal" class="jwx-modal-backdrop">
        <div
          ref="modal"
          class="jwx-modal"
          :data-width="props.width"
          :data-height="props.height"
        >
          <div class="jwx-modal__content">
            <CloseButton v-if="!props.hideCloseButton" @click.prevent="handleCloseModal" class="jwx-modal__close-button" />
  
            <slot></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>